export class HoldingReportListItemReqRes {
  public id: number;
  public periodStartDate: Date;
  public periodEndDate: Date;
  public publishDate: Date;
}
